import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const ApcCarrierInput = groupInput({
  shipperId: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
  facility: input<string>({ validator: nonEmptyValidator }),
});

export type ApcCarrierValue = InputSchema.Value<typeof ApcCarrierInput>;

export type ApcCarrierForm = InputSchema.Input<typeof ApcCarrierInput>;

export const apcCarrierDefault = (): ApcCarrierValue => ({
  shipperId: "",
  password: "",
  facility: "",
});

export const CreateApcCarrierForm = memo(function CreateApcCarrierForm({
  carrierInput,
}: {
  carrierInput: ApcCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Shipper ID"
        placeholder=""
        setValue={carrierInput.inputs.shipperId.setValue}
        value={carrierInput.inputs.shipperId.value}
      />
      <RedoTextInput
        label="Password"
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
      <RedoTextInput
        label="Facility"
        placeholder=""
        setValue={carrierInput.inputs.facility.setValue}
        value={carrierInput.inputs.facility.value}
      />
    </>
  );
});
